import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { TRANSLATIONS_RO } from './ro';
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    keySeparator: false,
    resources: {
        ro: {
            translation: TRANSLATIONS_RO
        }
    }
});
i18n.changeLanguage('ro');
export const translate = i18n.t.bind(i18n);
